import { useQuery } from '@tanstack/react-query'
import { useTenant } from '@/hooks/use-tenant'
import { tenantQuery } from '@/lib/supabase-tenant'

export function useUnreadCount() {
  const { schemaName, isReady } = useTenant()

  return useQuery<number>({
    queryKey: ['notifications', 'unread-count', schemaName],
    queryFn: async () => {
      const { count, error } = await tenantQuery(schemaName!)
        .from('notifications')
        .select('*', { count: 'exact', head: true })
        .eq('is_read', false)

      if (error) throw error
      return count ?? 0
    },
    enabled: isReady,
    refetchInterval: 30000,
  })
}
